import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const pdf = async (art = "luecken") => {
  try {
    const r = await axios.get(`${API}/admin/komplett-reparatur/${art}-pdf`, { responseType: "blob" });
    window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
  } catch (e) { toast.error("PDF fehlgeschlagen"); }
};

export const KomplettReparaturBlock = () => {
  const [st, setSt] = useState(null);
  const laden = () => axios.get(`${API}/admin/komplett-reparatur/status`).then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { laden(); }, []);
  useEffect(() => { if (!st?.laeuft) return undefined; const i = setInterval(laden, 8000); return () => clearInterval(i); }, [st?.laeuft]);
  const start = async () => {
    if (!window.confirm("Alle Wiederherstellungen für alle Teilnehmenden nacheinander ausführen? Das dauert eine Weile, die Seite darf geschlossen werden.")) return;
    try { await axios.post(`${API}/admin/komplett-reparatur/start`, {}); toast.success("Gestartet"); laden(); }
    catch (e) { toast.error(e.response?.data?.detail || "Start fehlgeschlagen"); }
  };
  return (
    <div className="border-2 border-[#1F2A44] rounded-lg p-4 mb-3" data-testid="komplett-reparatur-block">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-medium">Alles reparieren – Bildungsgutschein-Teilnehmende</p>
          <p className="text-sm text-muted-foreground" data-testid="komplett-reparatur-status">
            {st?.laeuft ? `Läuft: Schritt ${(st.schritt || 0) + 1}/${(st.schritte || []).length || 7} – ${st.schritt_name || "…"} ${st.schritt_detail ? `(${st.schritt_detail})` : ""}`
              : st?.fertig_am ? `Fertig ${new Date(st.fertig_am).toLocaleString("de-DE")} · ${(st.luecken || []).length} Teilnehmende mit Lücke` : "Verwaiste Unterlagen, Unterschriften/Originale, Anwesenheitslisten, Laufzettel, Postfach-Suche, danach Lückenliste"}
          </p>
        </div>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" onClick={async () => {
            try {
              const r = await axios.get(`${API}/admin/lueckenliste-azav-pdf`, { responseType: "blob" });
              window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
            } catch (e) { toast.error("PDF fehlgeschlagen"); }
          }} data-testid="lueckenliste-azav-pdf">Lückenliste AZAV</Button>
          <Button size="sm" variant="outline" onClick={() => pdf("luecken")} data-testid="komplett-reparatur-pdf">Lückenliste PDF</Button>
          <Button size="sm" variant="outline" onClick={() => pdf("aufgaben")} data-testid="komplett-reparatur-aufgaben-pdf">Aufgabenliste PDF</Button>
          <Button size="sm" disabled={st?.laeuft} onClick={start} data-testid="komplett-reparatur-start">{st?.laeuft ? "Läuft …" : "Alles reparieren"}</Button>
        </div>
      </div>
      {(st?.protokoll || []).length > 0 && (
        <ul className="mt-2 text-xs text-muted-foreground max-h-40 overflow-y-auto" data-testid="komplett-reparatur-protokoll">{st.protokoll.map((p, i) => <li key={i}>{p}</li>)}</ul>
      )}
      {!st?.laeuft && (st?.luecken || []).length > 0 && (
        <ul className="mt-2 text-sm divide-y max-h-72 overflow-y-auto" data-testid="komplett-reparatur-luecken">
          {st.luecken.map((l) => (
            <li key={l.name + l.kurs} className="py-1"><b>{l.name}</b> · {l.kurs} · <span className="text-red-600">{l.fehlt.join(", ")}</span>
              {(l.doppel || []).length > 0 && <span className="text-[#1F2A44]"> · liegt in Doppel-Datensatz: {l.doppel.join(", ")}</span>}
              {l.nach_beginn.length > 0 && <span className="text-[#B4502F]"> · mehr als 14 Tage nach Beginn unterschrieben: {l.nach_beginn.join(", ")}</span>}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
